import { render, staticRenderFns } from "./WorkflowKanbanCard.vue?vue&type=template&id=4709ed99"
import script from "./WorkflowKanbanCard.vue?vue&type=script&lang=js"
export * from "./WorkflowKanbanCard.vue?vue&type=script&lang=js"
import style0 from "./WorkflowKanbanCard.vue?vue&type=style&index=0&id=4709ed99&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports